import { useState } from "react";

function useCreate() {
    const [isCreate, setIsCreate] = useState(true);

    function toggleIsCreate(data: boolean) {
        setIsCreate(data);
    }

    return {
        isCreate,
        toggleIsCreate,
    }
}

export default useCreate;